import clsx from 'clsx';
import { useState, useEffect, useRef } from 'react';

import CheckIcon from '../Icon/CheckIcon';

import styles from './Alert.module.css';
import { AlertComponentProps } from './types';

const Alert = ({
  processing,
  finished,
  processMessage,
  finishMessage,
  vertical = 'center',
  horizontal = 'bottom',
  checkoutButtonAvailable,
  duration = 4000,
}: AlertComponentProps) => {
  const timerAutoHide = useRef<any>(0);
  const [open, setOpen] = useState(processing || finished);
  const [message, setMessage] = useState<any>('');
  const [popupIsVisible, setPopupIsVisible] = useState<boolean>(false);

  const classNames: string = clsx(
    styles.Alert,
    { [styles.AlertCenter]: vertical === 'center' },
    { [styles.AlertLeft]: vertical === 'left' },
    { [styles.AlertRight]: vertical === 'right' },
    { [styles.AlertBottom]: horizontal === 'bottom' },
    { [styles.AlertTop]: horizontal === 'top' },
    { [styles.AlertBottomMobile]: popupIsVisible },
    {
      [styles.AlertValuedCustomerPopup]: checkoutButtonAvailable && popupIsVisible,
    },
  );

  const contentClassNames: string = clsx(styles.AlertContent, styles.Alert_animation, {
    'updateOrderAlert': finished,
  });

  const closeSnackbar = (): void => {
    setOpen(false);
    setMessage('');
  };

  const isVisible = (el: Element | null): boolean => {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    return style.transform === 'matrix(1, 0, 0, 1, 0, 0)';
  };

  const setPopupVisibility = (): void => {
    setOpen(processing || finished);
    const popup = document.getElementById('cart-summary-popup');
    setPopupIsVisible(isVisible(popup));
  };

  useEffect(() => {
    setPopupVisibility();
    setMessage(
      processing ? (
        processMessage
      ) : (
        <>
          <CheckIcon /> {finishMessage}
        </>
      ),
    );
    clearTimeout(timerAutoHide.current);
    timerAutoHide.current = setTimeout(() => {
      closeSnackbar();
    }, duration);
    return () => {
      clearTimeout(timerAutoHide.current);
    };
  }, [processing, finished]);

  return (
    <>
      {open && (
        <div aria-hidden className={classNames}>
          <div className={contentClassNames}>{message}</div>
        </div>
      )}
    </>
  );
};

export default Alert;
